/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Hint_FullscreenInputs */

const en_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fullscreen`)
};

const ar_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملء الشاشة`)
};

const bn_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফুলস্ক্রিন`)
};

const de_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollbild`)
};

const es_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pantalla completa`)
};

const fr_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plein écran`)
};

const pt_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tela cheia`)
};

const zh_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全屏`)
};

const tr_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tam ekran`)
};

const ru_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`полный экран`)
};

const pl_image_inspector_hint_fullscreen = /** @type {(inputs: Image_Inspector_Hint_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pełny ekran`)
};

/**
* | output |
* | --- |
* | "fullscreen" |
*
* @param {Image_Inspector_Hint_FullscreenInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_hint_fullscreen = /** @type {((inputs?: Image_Inspector_Hint_FullscreenInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Hint_FullscreenInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_hint_fullscreen(inputs)
	if (locale === "bn") return bn_image_inspector_hint_fullscreen(inputs)
	if (locale === "de") return de_image_inspector_hint_fullscreen(inputs)
	if (locale === "es") return es_image_inspector_hint_fullscreen(inputs)
	if (locale === "fr") return fr_image_inspector_hint_fullscreen(inputs)
	if (locale === "pt") return pt_image_inspector_hint_fullscreen(inputs)
	if (locale === "zh") return zh_image_inspector_hint_fullscreen(inputs)
	if (locale === "tr") return tr_image_inspector_hint_fullscreen(inputs)
	if (locale === "ru") return ru_image_inspector_hint_fullscreen(inputs)
	if (locale === "pl") return pl_image_inspector_hint_fullscreen(inputs)
	return en_image_inspector_hint_fullscreen(inputs)
});